import { render, staticRenderFns } from "./HistoryOperaciones.vue?vue&type=template&id=87cd33cc"
import script from "./HistoryOperaciones.vue?vue&type=script&lang=js"
export * from "./HistoryOperaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports